import { JSX } from "react";
import { Breadcrumbs } from "@hatch-digital-nl/bravilor-storybook";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { CategoryInterface } from "../../../common/interfaces/CategoryInterface";
import { DstProductDetailViewModel } from "../interfaces/ProductDetailViewTypes";
import { DstProductDetailLabels } from "../utils/productDetailLabels";
import { getLocalizedText } from "../../../common/utils/getLocalizedText";

const ACCESSORIES_CATEGORY_ID = 139;

interface Props {
    data: DstProductDetailViewModel | undefined;
    isPageLoading: boolean;
    labels: DstProductDetailLabels;
}

export const ProductDetailsHeader = ({
    data,
    isPageLoading,
    labels,
}: Props): JSX.Element => {
    if (isPageLoading || !data) {
        return (
            <div className="c-breadcrumbs">
                <Breadcrumbs isLoading items={[]} />
            </div>
        );
    }

    const isAccessory = data.categories.includes(ACCESSORIES_CATEGORY_ID);

    return (
        <div className="c-breadcrumbs">
            <Breadcrumbs
                items={[
                    {
                        label: labels.productRange,
                        to: RouteEnum.PRODUCT_RANGE,
                    },
                    {
                        label: isAccessory
                            ? labels.accessories
                            : labels.machines,
                        to: RouteEnum.PRODUCT_RANGE,
                    },
                    {
                        label: data.label,
                    },
                ]}
            />
        </div>
    );
};

export const buildProductBreadcrumbs = (
    productCategories: CategoryInterface[],
    productLabel: string,
): Array<{ label: string }> => [
    ...productCategories.map((category) => ({
        label: getLocalizedText(category.label),
    })),
    {
        label: productLabel,
    },
];
